import { render, staticRenderFns } from "./UploadFileAdvanced.vue?vue&type=template&id=3393ac21&"
import script from "./UploadFileAdvanced.vue?vue&type=script&lang=js&"
export * from "./UploadFileAdvanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3393ac21')) {
      api.createRecord('3393ac21', component.options)
    } else {
      api.reload('3393ac21', component.options)
    }
    module.hot.accept("./UploadFileAdvanced.vue?vue&type=template&id=3393ac21&", function () {
      api.rerender('3393ac21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61221000-4/components/UploadFileAdvanced.vue"
export default component.exports